import { render } from "./GlobalMapPopup.vue?vue&type=template&id=02f9b4d2"
import script from "./GlobalMapPopup.vue?vue&type=script&lang=js"
export * from "./GlobalMapPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__